<template>
    <div class="container mt-5">
        <div class="row align-items-center">
            <div class="col-md-12 text-center">
                <img src="@/assets/briva.svg" alt="Logo" class="img-fluid" style="width: 60%;">
            </div>
        </div>
        <br>
        <h1 class="text-center">BRI Virtual Account (BRIVA)</h1>
        <div id="collapseContainer" class="row border rounded p-4 custom-collapse" style="border: 1px solid #ced4da; background-color: #ffffff;">
            <div class="col-md-12">
                <h4>Pembayaran Briva</h4>
                <p>Bagaimana cara pembayaran melalui BRIVA?</p>
            </div>

            <div class="col-md-6 collapse-col" v-for="(method, index) in paymentMethods" :key="index">
                <div class="card">
                    <div class="card-header" @click="toggleCollapse(index)" :aria-expanded="activeCollapse === index" :aria-controls="'collapse' + index">
                        {{ method.title }}
                        <i class="fas fa-chevron-down collapse-icon"></i>
                    </div>
                    <div class="collapse" :class="{ show: activeCollapse === index }" :id="'collapse' + index">
                        <div class="card-body">
                            <ol>
                                <li v-for="(step, stepIndex) in method.steps" :key="stepIndex">{{ step }}</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeCollapse: null,  // Track the currently active collapse section
            paymentMethods: [      // List of payment methods with steps
                {
                    title: "Teller BRI",
                    steps: [
                        "Ambil nomor antrian transaksi teller dan isi slip setoran",
                        "Isikan 15 angka Nomor Pembayaran Tilang pada kolom 'Nomor Rekening' dan nominal titipan denda tilang pada slip setoran",
                        "Serahkan slip setoran kepada Teller BRI",
                        "Teller BRI akan melakukan validasi transaksi",
                        "Simpan Slip Setoran hasil validasi sebagai bukti pembayaran yang sah",
                        "Slip setoran diserahkan ke penindak untuk ditukarkan dengan barang bukti yang disita"
                    ]
                },
                {
                    title: "ATM BRI",
                    steps: [
                        "Masukkan Kartu Debit BRI dan PIN Anda",
                        "Pilih menu Transaksi Lain > Pembayaran > Lainnya > BRIVA",
                        "Masukkan 15 angka Nomor Pembayaran Tilang",
                        "Di halaman konfirmasi, pastikan detil pembayaran sudah sesuai seperti Nomor BRIVA, Nama Pelanggar, dan Jumlah Pembayaran",
                        "Ikuti instruksi untuk menyelesaikan transaksi",
                        "Copy struk ATM sebagai bukti pembayaran yang sah dan simpan",
                        "Struk ATM asli diserahkan ke penindak untuk ditukarkan dengan barang bukti yang disita"
                    ]
                },
                {
                    title: "Mobile Banking BRI",
                    steps: [
                        "Login aplikasi BRI Mobile",
                        "Pilih Menu Mobile Banking BRI > Pembayaran > BRIVA",
                        "Masukkan 15 angka Nomor Pembayaran Tilang",
                        "Masukkan nominal pembayaran sesuai jumlah denda yang harus dibayarkan. Transaksi akan ditolak jika pembayaran tidak sesuai dengan jumlah denda titipan",
                        "Masukkan PIN",
                        "Simpan notifikasi SMS sebagai bukti pembayaran",
                        "Tunjukkan notifikasi SMS ke penindak untuk ditukarkan dengan barang bukti yang disita"
                    ]
                },
                {
                    title: "Internet Banking BRI",
                    steps: [
                        "Login pada alamat Internet Banking BRI (https://ib.bri.co.id/ib-bri/Login.html)",
                        "Pilih menu Pembayaran Tagihan > Pembayaran > BRIVA",
                        "Pada kolom kode bayar, Masukkan 15 angka Nomor Pembayaran Tilang",
                        "Di halaman konfirmasi, pastikan detil pembayaran sudah sesuai seperti Nomor BRIVA, Nama Pelanggar, dan Jumlah Pembayaran",
                        "Masukkan password dan mToken",
                        "Cetak/simpan struk pembayaran BRIVA sebagai bukti pembayaran",
                        "Tunjukkan bukti pembayaran ke penindak untuk ditukarkan dengan barang bukti yang disita"
                    ]
                },
                {
                    title: "EDC BRI",
                    steps: [
                        "Pilih menu Mini ATM > Pembayaran > BRIVA",
                        "Swipe kartu Debit BRI Anda",
                        "Masukkan 15 angka Nomor Pembayaran Tilang",
                        "Masukkan PIN",
                        "Di halaman konfirmasi, pastikan detil pembayaran sudah sesuai seperti Nomor BRIVA, Nama Pelanggar, dan Jumlah Pembayaran",
                        "Copy dan simpan struk transaksi sebagai bukti pembayaran",
                        "Tunjukkan bukti pembayaran ke penindak untuk ditukarkan dengan barang bukti yang disita"
                    ]
                },
                {
                    title: "Transfer dari Bank Lain",
                    steps: [
                        "Masukkan kartu Debit dan PIN Anda",
                        "Pilih menu Transaksi Lainnya > Transfer > Ke Rek Bank Lain",
                        "Masukkan kode bank BRI (002) kemudian diikuti dengan 15 angka Nomor Pembayaran Tilang",
                        "Masukkan nominal pembayaran sesuai jumlah denda yang harus dibayarkan. Transaksi akan ditolak jika pembayaran tidak sesuai dengan jumlah denda titipan",
                        "Ikuti instruksi untuk menyelesaikan transaksi",
                        "Simpan struk transaksi sebagai bukti pembayaran"
                    ]
                }
            ]
        };
    },
    methods: {
        toggleCollapse(index) {
            // Toggle the collapse state of the selected method
            this.activeCollapse = this.activeCollapse === index ? null : index;
        }
    }
}
</script>

<style scoped>
.collapse-col {
    margin-bottom: 20px;
}
.collapse-icon {
    float: right;
}
</style>
